import { useEffect } from 'react';
declare global {
  interface Window {
    Tawk_API?: Record<string, unknown>;
    Tawk_LoadStart?: Date;
  }
}
const SRC = 'https://embed.tawk.to/675309132480f5b4f5a8c301/1iee5mt9j';
export function TawkToWidget() {
  useEffect(() => {
    if (document.querySelector(`script[src="${SRC}"]`)) return;
    window.Tawk_API = window.Tawk_API || {};
    window.Tawk_LoadStart = new Date();
    // Anchor the bubble to the bottom-left corner on every viewport.
    window.Tawk_API.customStyle = {
      visibility: {
        desktop: {
          position: 'bl',
          xOffset: 24,
          yOffset: 24
        },
        mobile: {
          position: 'bl',
          xOffset: 12,
          yOffset: 12
        }
      }
    };
    const script = document.createElement('script');
    script.async = true;
    script.src = SRC;
    script.charset = 'UTF-8';
    script.setAttribute('crossorigin', '*');
    document.body.appendChild(script);
  }, []);
  return null;
}